<template>
  <img
    src="../assets/img/oktaOidcLogo.png"
    alt="OIDC Icon"
    width="16"
    height="16"
  />
</template>
